<template>
  <v-navigation-drawer v-model="isDrawer" app right temporary>
    <v-container fluid class="pa-0 ma-0">
      <v-layout row wrap class="pa-0 ma-0">

        <v-btn icon @click="isDrawer = false" style="position: absolute; right: 0; margin-right: 10px;">
          <v-icon size="24px" color="#a9a9af">$vuetify.icons.cancel</v-icon>
        </v-btn>

        <!-- 로그인 후 -->
        <v-container fluid class="pa-0 align-start" style="height: 100%;" v-if="idx">
          <v-layout column class="mt-3 pb-2 mx-4">
            <v-avatar size="56px">
              <v-img v-if="changedProfileImage" :src="changedProfileImage.url"></v-img>
              <v-img v-else :src="profileImageSrc" @error="isProfileLoaded = false"></v-img>
              <input ref="profileImageUpload" name="img-uploads" type="file" accept="image/*" multiple @change="onFileChanged" style="display: none;">
              <v-btn icon dark color="black" absolute class="profile-change-button" @click="$refs.profileImageUpload.click()">
                <v-icon size="16px">$vuetify.icons.camera</v-icon>
              </v-btn>
            </v-avatar>
            <div class="text-xs-left mt-4">
              <div class="user-name" v-text="name"></div>
              <div class="body-2" v-text="email"></div>
            </div>
          </v-layout>
          <v-list style="padding-top: 56px;">
            <v-list-tile @click="$router.push({ name: 'Notifications' })" class="drawer-list-tile">
              <v-list-tile-content>
                <v-list-tile-title>알림</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action style="font-size: 18px;">
<!--                <span><span style="font-weight: 700;">{{ notificationsUpdatedCnt }}</span> 개</span>-->
                <v-badge overlap class="badge-position">
                  <template v-slot:badge v-if="notificationsUpdatedCnt">
                    <span>{{ notificationsUpdatedCnt }}</span>
                  </template>
                  <v-icon>$vuetify.icons.bell</v-icon>
                </v-badge>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile @click="$router.push({ name: 'Bookmarks' })" class="drawer-list-tile">
              <v-list-tile-content>
                <v-list-tile-title>북마크</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action style="font-size: 18px;">
                <span><span style="font-weight: 700;">{{ bookmark_cnt }}</span> 개</span>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile @click="$router.push({ name: 'Purchases' })" class="drawer-list-tile">
              <v-list-tile-content>
                <v-list-tile-title>구매목록</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile @click="$router.push({ name: 'Settings'})" class="drawer-list-tile">
              <v-list-tile-content>
                <v-list-tile-title>설정</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
<!--          <v-layout row class="counter-wrapper">-->
<!--            <v-flex xs6 style="padding-left: 70px;">-->
<!--              <v-btn icon class="counter ma-0" @click="$router.push({ name: 'Bookmarks' })">-->
<!--                {{ bookmark_cnt }}-->
<!--              </v-btn>-->
<!--              <div class="counter-text">북마크</div>-->
<!--            </v-flex>-->
<!--            <v-divider vertical class="mt-2"></v-divider>-->
<!--            <v-flex xs6 style="padding-right: 70px;">-->
<!--              <v-btn icon class="counter ma-0" @click="$router.push({ name: 'Home', query: { to: 'Subscription' } })">-->
<!--                {{ subscribe_cnt }}-->
<!--              </v-btn>-->
<!--              <div class="counter-text">구독중</div>-->
<!--            </v-flex>-->
<!--          </v-layout>-->
        </v-container>

        <!-- 로그인 전 -->
        <v-container fluid class="pt-0 justify-center" v-else>
          <v-layout row class="pl-3 pr-2 align-center justify-space-between">
            <div class="text-xs-left text-line-break mr-3 mt-5">
              <div class="body-1 badge" style="color: black; margin-bottom: 16px;">아직 로그인을 하지 않으셨네요!</div>
              <div class="login-text" style="cursor: pointer" @click="$router.push({ name: 'SocialLogin' })">유스 회원가입<br>/ 로그인하기</div>
            </div>
            <img src="@/assets/img/login.png" style="margin-top: 5px; width: 56px; height: 56px;" @click="$router.push({ name: 'SocialLogin' })">
          </v-layout>
        </v-container>

        <v-flex xs12 style="background-color: white;" class="mt-2">
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs3 v-for="(item, index) in menu" :key="index">
                <v-btn color="white" class="pa-0 ma-0 button-style" @click="linkTo(item.to)">
                  <img :src="`${$baseUrl}/static/img/icon-${item.icon}.png`" style="width: 64px; height: 64px; margin-top: -9px; flex-shrink: 0;">
                </v-btn>
                <div class="pt-2 button-text">{{ item.name }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import EXIF from 'exif-js';

  export default {
    name: 'MoreDrawer',
    computed: {
      ...mapGetters([ 'drawer' ]),
      ...mapGetters('user', [ 'idx', 'email', 'name', 'profile_image', 'bookmark_cnt', 'subscribe_cnt' ]),
      ...mapGetters('home', [ 'notificationsUpdatedCnt' ]),
      profileImageSrc () {
        return this.profile_image && this.isProfileLoaded ? `${this.$storage}/user/profile/${this.profile_image}` : require('@/assets/img/profile-default.png');
      },
      isDrawer: {
        get () {
          return this.drawer;
        },
        set (flag) {
          this.toggleDrawer(flag);
        }
      }
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        isProfileLoaded: true,
        changedProfileImage: null,
        menu: [
          { name: '찜목록', to: 'Wishes', icon: 'double-heart' },
          // { name: '알림', to: 'Notice', icon: 'alarm' },
          // { name: '이벤트', to: 'Events', icon: 'event' },
          // { name: '구매목록', to: 'Purchases', icon: 'purchase-list' },
          // { name: '친구추천', to: 'Invite', icon: 'recommend' },
          { name: '보유쿠폰', to: 'Coupons', icon: 'coupon' },
          { name: '유스블로그', to: 'NaverBlog', icon: 'blog' },
          { name: '문의하기', to: 'Inquiry', icon: 'suggestion' },
        ]
      };
    },
    created () {
      const auth = window.localStorage.getItem('jwt');
      if (typeof auth === 'string' && auth !== '') {
        this.selectCounter(this.time);
      }
    },
    methods: {
      ...mapActions([ 'toggleDrawer' ]),
      ...mapActions('user', [ 'selectCounter', 'updateUserProfileImage', 'setJWT', 'setUser' ]),
      linkTo (routeName) {
        if (routeName === 'NaverBlog') {
          window.open('https://blog.naver.com/saranginc');
        } else if (routeName === 'Inquiry') {
          // eslint-disable-next-line
          Kakao.PlusFriend.chat({
            plusFriendId: '_ygxjIT'
          });
        } else {
          this.$router.push({ name: routeName });
        }
      },
      onFileChanged (event) {
        let file = event.target.files[0];
        if (/^image\//i.test(file.type)) this.readFile(file);
      },
      // image file read & process
      readFile (file) {
        let reader = new FileReader();
        let root = this;
        reader.onloadend = function () {
          root.processFile(reader.result, file.type);
        };
        reader.onerror = function () {
          // alert('error');
          // root.showModal({ flag: true, which: `Alert#${root.$t('error')}` });
        };
        reader.readAsDataURL(file);
      },
      processFile (dataURL, fileType) {
        // TODO: EXIF extract and orient the image
        let maxWidth = 200;
        let maxHeight = 200;
        let image = new Image();
        image.src = dataURL;
        let root = this;
        image.onload = function () {
          let width = image.width;
          let height = image.height;
          let shouldResize = (width > maxWidth) || (height > maxHeight);
          if (!shouldResize) {
            root.appendFile(dataURL);
            return;
          }
          let sx = 0;
          let sy = 0;
          let sWidth = image.width;
          let sHeight = image.height;
          if (width > height) {
            sx = width / 2 - height / 2;
            sWidth = sHeight;
          } else if (width < height) {
            sy = height / 2 - width / 2;
            sHeight = sWidth;
          }
          let canvas = document.createElement('canvas');
          canvas.width = 200;
          canvas.height = 200;
          let context = canvas.getContext('2d');
          EXIF.getData(image, () => {
            const tags = EXIF.getAllTags(image);
            console.log(tags);
            root.transformCoordinates(canvas, tags);
          });
          context.drawImage(this, sx, sy, sWidth, sHeight, 0, 0, 200, 200);
          dataURL = canvas.toDataURL(fileType);
          root.appendFile(dataURL);
        };
        image.onerror = function () {
          // alert('error');
          // root.showModal({ flag: true, which: `Alert#${root.$t('shared')}` });
        };
      },
      appendFile (dataURL) {
        let blob = this.dataURItoBlob(dataURL);
        this.changedProfileImage = { url: dataURL, file: blob };
        let formData = new FormData();
        formData.append('files', blob);
        // formData.append('deleted', this.profile_image);
        this.updateUserProfileImage(formData).then(response => {
          this.setUser({ profile_image: response.data.profile_image });
          this.setJWT(response.data.token);
        }).catch(err => {
          console.error(err);
        });
      },
      dataURItoBlob (dataURI) {
        let byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      transformCoordinates (canvas, options) {
        let ctx = canvas.getContext('2d');
        let width = canvas.width;
        let height = canvas.height;
        let styleWidth = canvas.style.width;
        let styleHeight = canvas.style.height;
        let orientation = options.Orientation;
        console.log(orientation);
        if (!orientation || orientation > 8) {
          return;
        }
        if (orientation > 4) {
          canvas.width = height;
          canvas.height = width;
          canvas.style.width = styleHeight;
          canvas.style.height = styleWidth;
        }
        switch (orientation) {
          case 2:
            // horizontal flip
            ctx.translate(width, 0);
            ctx.scale(-1, 1);
            break;
          case 3:
            // 180° rotate left
            ctx.translate(width, height);
            ctx.rotate(Math.PI);
            break;
          case 4:
            // vertical flip
            ctx.translate(0, height);
            ctx.scale(1, -1);
            break;
          case 5:
            // vertical flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.scale(1, -1);
            break;
          case 6:
            // 90° rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(0, -height);
            break;
          case 7:
            // horizontal flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(width, -height);
            ctx.scale(-1, 1);
            break;
          case 8:
            // 90° rotate left
            ctx.rotate(-0.5 * Math.PI);
            ctx.translate(-width, 0);
            break;
        }
      },
      // end
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.extension-shadow .v-toolbar__extension {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/ .v-toolbar__extension {
    padding: 0;
  }

  /deep/.drawer-list-tile .v-list__tile {
    height: 56px;
    border-bottom: 1px solid #f4f4f4;
    padding-left: 24px;
    padding-right: 24px;

    font-size: 20px;
    letter-spacing: -1px;
    color: #4a4a4a;
  }

  .badge {
    position: relative;
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: -6px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: map_get($colors, primary);
    }
  }

  .login-text {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.3px;
    color: black;
    text-decoration: underline;
  }
  .text-line-break {
    word-break: keep-all;
    word-wrap: break-word;
  }

  .profile-change-button {
    width: 22px !important;
    height: 22px;
    right: 0;
    bottom: 0;
  }
  .user-name {
    font-size: 18px;
    letter-spacing: -0.5px;
    font-weight: 700;
  }

  .body-2 {
    color: map_get($colors, charcoal);
  }

  .counter {
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    color: map_get($colors, charcoal);

    &-wrapper .v-divider {
      height: 39px;
      border-color: map_get($colors, primary) !important;
    }

    &-text {
      font-size: 12px;
      color: map_get($colors, charcoal);
    }
  }

  .button {
    &-style {
      border-radius: 10px;
      min-width: 0;
      width: 46px;
      height: 46px;
      box-shadow: 0 0 10px rgba(#eaeaea, 0.5) !important;
    }
    &-text {
      font-size: 10px;
      color: map_get($colors, brownish-grey);
    }
  }

  /deep/.badge-position .v-badge__badge {
    top: -3px;
    right: -9px;
    width: auto;
    height: 14px;
    padding: 0 5px;
    border-radius: 8.5px;

    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2px;
  }

</style>
